import {
  type AnswerApprovalResponse,
  answerApprovalResponseSchema,
  type ApprovalDecision,
  approvalPath,
} from '@salescore/agent-contract'
import { Effect } from 'effect'

import { type AgentApi, type AgentApiError, parseJsonResponse } from './agentApi'

// 承認のカードの回答を、runtime の approve に取り次ぐ API（POST .../turns/{turnId}/approvals/{approvalId}）の呼び出し

/**
 * 承認の要求に、利用者の回答（許可か拒否）を返す。受け付けられなかったときも成功で返し、理由を accepted: false で持つ。
 * runtime は、受け付けると待たせていたツールの呼び出しを進めるか止め、その結果はツールの呼び出しの通知で届く
 */
export const answerAgentApproval = (
  api: AgentApi,
  target: { agentSessionId: string; turnId: string; approvalId: string },
  decision: ApprovalDecision,
): Effect.Effect<AnswerApprovalResponse, AgentApiError> =>
  api(approvalPath(target), { method: 'POST', body: JSON.stringify({ decision }) }).pipe(
    Effect.flatMap((response) => parseJsonResponse(response, answerApprovalResponseSchema)),
  )
